module.exports = __webpack_public_path__ + "static/media/header1.4a9f2288.jpg";